/**
 * Main entry point for The Identity Underground
 * GSAP is loaded externally via Webflow (not imported here)
 */

import '../styles/main.css';
import './lightbox.js';
import { initStickyNavbar } from './sticky-navbar.js';
import { initSplitTextAnimations } from './splittext-animations.js';
import { initSplitTextQuote } from './splittext-quote.js';
import { initHighlightText } from './highlight-text-on-scroll.js';
import { initMemberListAnimation } from './member-list-animation.js';
import { initGalleryAnimation } from './gallery-animation.js';
import { initAccordionCSS } from './accordion-css.js';
import { initDownloadButtons } from './download-button.js';
import { initCopyEmailClipboard } from './copy-email-to-clipboard-button.js';
import { initRadialProgress } from './radial-progress.js';
import { initSocialShare } from './social-share-buttons.js';

// Initialize when DOM is ready
window.addEventListener('DOMContentLoaded', () => {
  // console.log('The Identity Underground - Initialized');
  
  // Initialize all modules
  initStickyNavbar();
  initSplitTextAnimations();
  initSplitTextQuote();
  initHighlightText();
  initMemberListAnimation();
  initGalleryAnimation();
  initAccordionCSS();
  initDownloadButtons();
  initCopyEmailClipboard();
  initRadialProgress();
  initSocialShare();
});
